"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("react-calendar/dist/Calendar.css");
var Input_1 = __importDefault(require("../Input"));
var Calendar_1 = __importDefault(require("../Calendar"));
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var useClickOutside_1 = __importDefault(require("../helpers/useClickOutside"));
var Icon_1 = __importDefault(require("../Icon"));
var date_fns_1 = require("date-fns");
var useStyles = (0, react_jss_1.createUseStyles)({
    wrap: {
        display: 'inline-block',
    },
    datePicker: function (props) { return ({
        cursor: 'pointer',
        width: props.size === 'stretch' ? '100%' : 296,
    }); },
    calendar: function (props) { return ({
        width: props.size === 'stretch' ? '100%' : 296,
    }); },
});
var DatePicker = function (props) {
    var styles = useStyles(props);
    var defaultDate = props.defaultDate, className = props.className, calendarOptions = props.calendarOptions, inputClassName = props.inputClassName, onChange = props.onChange, dateFormatter = props.dateFormatter, rest = __rest(props, ["defaultDate", "className", "calendarOptions", "inputClassName", "onChange", "dateFormatter"]);
    var _a = (0, react_1.useState)(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = (0, react_1.useState)(defaultDate), selectedDate = _b[0], setDate = _b[1];
    var pickerRef = (0, react_1.useRef)(null);
    (0, useClickOutside_1.default)(pickerRef, function () {
        if (!isOpen)
            return;
        setIsOpen(false);
    });
    var dateValue = (0, react_1.useMemo)(function () {
        if (!selectedDate)
            return '';
        return dateFormatter
            ? dateFormatter(selectedDate)
            : (0, date_fns_1.format)(selectedDate, 'PP');
    }, [selectedDate, dateFormatter]);
    return (react_1.default.createElement("div", { ref: pickerRef, className: (0, classnames_1.default)(styles.wrap, className) },
        react_1.default.createElement(Input_1.default, __assign({ value: dateValue, className: (0, classnames_1.default)(styles.datePicker, inputClassName), onClick: function () { return setIsOpen(true); }, readOnly: true, placeholder: 'Select a day', icon: react_1.default.createElement(Icon_1.default, { name: selectedDate ? 'calendarFull' : 'calendarEmpty', size: 'md' }), onChange: function () { return null; } }, rest)),
        isOpen && (react_1.default.createElement(Calendar_1.default, __assign({ value: selectedDate, onChange: function (date, e) {
                setDate(date);
                setIsOpen(false);
                onChange && onChange(date, e);
            }, className: styles.calendar }, calendarOptions)))));
};
exports.default = DatePicker;
//# sourceMappingURL=index.js.map